module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_VIDEO_1.f5f61845.webm";